import apiService from '@/providers/apiService';
import AppConstants from '@/appConstants';
import newsService from '@/providers/newsService';

export default {
  namespaced: true,
  state: {
    disclosureType: [],
    selectedDisclosureType: [],
    newsType: [],
    selectedNewsType: [],
    origins: [],
    selectedOrigins: [],
    regions: [],
    selectedRegion: null,
    importing: false
  },
  getters: {},
  mutations: {
    SET_SELECTED_NEWS_TYPE(state, val) {
      state.selectedNewsType = val
    },
    SET_NEWS_TYPE(state, val) {
      state.newsType = val
    },
    SET_SELECTED_DISCLOSURE_TYPE(state, val) {
      state.selectedDisclosureType = val
    },
    SET_DISCLOSURE_TYPE(state, val) {
      state.disclosureType = val
    },
    SET_SELECTED_ORIGINS(state, val) {
      state.selectedOrigins = val
    },
    SET_ORIGINS(state, val) {
      state.origins = val
    },
    SET_REGIONS(state, val) {
      state.regions = val
    },
    SET_SELECTED_REGION(state, val) {
      state.selectedRegion = val
    },
    SET_IMPORTING(state, val) {
      state.importing = val
    },
  },
  actions: {
    fetchNews(ctx, { params }) {
      return new Promise((resolve, reject) => {
        newsService
        .manageNews(params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      })
    },
    fetchEvents(ctx, { params }) {
      return new Promise((resolve, reject) => {
        apiService.get(AppConstants.URL_CALENDAR_GETALL, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    fetchEventDetail(ctx, { params }) {
      return new Promise((resolve, reject) => {
        apiService.get(AppConstants.URL_CALENDAR_DETAIL, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    updateEvent(ctx, { form, params }) {
      return new Promise((resolve, reject) => {
        apiService.post(AppConstants.URL_CALENDAR_UPDATE, form, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    addEvent(ctx, { form, params }) {
      return new Promise((resolve, reject) => {
        apiService.post(AppConstants.URL_CALENDAR_REGISTER, form, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    removeEvent(ctx, { params }) {
      return new Promise((resolve, reject) => {
        apiService.delete(AppConstants.URL_CALENDAR_DELETE, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    getOrigins(ctx, { params }) {
      return new Promise((resolve, reject) => {
        apiService.get(AppConstants.URL_DROPDOWN_ORIGIN, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
    importEvents(ctx, { form, params }) {
      return new Promise((resolve, reject) => {
        apiService.post(AppConstants.URL_CALENDAR_IMPORT, form, params)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      })
    },
  },
}
